unit View.Fornecedores.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UFrameFinanceiroFornecedor, Vcl.Forms, WEBLib.Grids,
  WEBLib.Lists, System.DateUtils, Grid.Plugins, UConstantes, System.StrUtils;

type
  TFViewFornecedoresEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbrazao_social_nome: TLabel;
    edrazao_social_nome: TDBEdit;
    lbnome_fantasia_apelido: TLabel;
    ednome_fantasia_apelido: TDBEdit;
    lbcpf_cnpj: TLabel;
    edcpf_cnpj: TDBEdit;
    lbrg_ie: TLabel;
    edrg_ie: TDBEdit;
    lbis_pj: TLabel;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbcontato: TLabel;
    edcontato: TDBEdit;
    lbendereco: TLabel;
    edendereco: TDBEdit;
    lbcep: TLabel;
    edcep: TDBEdit;
    lbcidade_id: TLabel;
    edcidade_id: TDBEdit;
    lbtelefones: TLabel;
    edtelefones: TDBEdit;
    lbprodutor_rural: TLabel;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFornecedoresGet: TXDataWebClient;
    FornecedoresDataset: TXDataWebDataSet;
    FornecedoresDatasetid: TIntegerField;
    FornecedoresDatasetaliado_id: TIntegerField;
    FornecedoresDatasetdata_base_id: TIntegerField;
    FornecedoresDatasetrazao_social_nome: TStringField;
    FornecedoresDatasetnome_fantasia_apelido: TStringField;
    FornecedoresDatasetcpf_cnpj: TStringField;
    FornecedoresDatasetrg_ie: TStringField;
    FornecedoresDatasetis_pj: TBooleanField;
    FornecedoresDatasetcadastro: TDateTimeField;
    FornecedoresDatasetstatus: TIntegerField;
    FornecedoresDatasetemail: TStringField;
    FornecedoresDatasetcontato: TStringField;
    FornecedoresDatasetendereco: TStringField;
    FornecedoresDatasetnumero: TStringField;
    FornecedoresDatasetbairro: TStringField;
    FornecedoresDatasetcomplemento: TStringField;
    FornecedoresDatasetcep: TStringField;
    FornecedoresDatasetcidade_id: TIntegerField;
    FornecedoresDatasettelefones: TStringField;
    FornecedoresDatasetprodutor_rural: TBooleanField;
    FornecedoresDatasetcodigo_interno: TIntegerField;
    FornecedoresDatasetexcluido: TBooleanField;
    FornecedoresDatasetinclusao: TDateTimeField;
    FornecedoresDatasetalteracao: TDateTimeField;
    FornecedoresDatasetexclusao: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxis_pj: TDBCheckBox;
    cbxprodutor_rural: TDBCheckBox;
    FornecedoresDatasetcidadeNome: TStringField;
    FornecedoresDatasetcidadeufSigla: TStringField;
    btnFinanceiroTab: TButton;
    frmFinanceiro: TfrmFinanceiroFornecedor;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientFornecedoresGetLoad(Response: TXDataClientResponse);
    procedure FornecedoresDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure FornecedoresDatasetcpf_cnpjGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure FornecedoresDatasetstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure FornecedoresDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure FornecedoresDatasetenderecoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure FornecedoresDatasettelefonesGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure FornecedoresDatasetcidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure btnFinanceiroTabClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFornecedoresEdit: TFViewFornecedoresEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFornecedoresEdit }

procedure TFViewFornecedoresEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if btnFinanceiroTab.Tag = 1 then
    Exit;

  frmFinanceiro.CarregarInformacoesIniciais(edid.Text);
  btnFinanceiroTab.Tag := 1;
end;

class function TFViewFornecedoresEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFornecedoresEdit.InsertEntity;
begin
  FornecedoresDataset.Close;
  FornecedoresDataset.SetJsonData('{}');
  FornecedoresDataset.Open;
  FornecedoresDataset.Insert;
end;

class function TFViewFornecedoresEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFornecedoresEdit(AForm).FInserting := AInserting;
    TFViewFornecedoresEdit(AForm).FId := AId;
    TFViewFornecedoresEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFornecedoresEdit(AForm).InsertEntity
    else
      TFViewFornecedoresEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFornecedoresEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFornecedoresEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    FornecedoresDataset.Connection.Model.DefaultSchema.FindEntityType(
      FornecedoresDataset.EntitySetName
    )
  );
  XDataClientFornecedoresGet.Get(FornecedoresDataset.EntitySetName, QueryString + ',cidade/uf', FId);
end;

procedure TFViewFornecedoresEdit.XDataClientFornecedoresGetLoad(Response: TXDataClientResponse);
begin
  FornecedoresDataset.Close;
  FornecedoresDataset.SetJsonData(Response.Result);
  FornecedoresDataset.Open;
  
  FornecedoresDataset.Edit;  
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      //ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetcidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, FornecedoresDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetcpf_cnpjGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetenderecoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(FornecedoresDataset.FieldByName('endereco').AsString,
    FornecedoresDataset.FieldByName('numero').AsString, FornecedoresDataset.FieldByName('bairro').AsString,
      FornecedoresDataset.FieldByName('complemento').AsString, False);
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasetstatusGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.GetNomeStatusFornecedor(Sender.AsInteger);
end;

procedure TFViewFornecedoresEdit.FornecedoresDatasettelefonesGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTodosTelefonesJson(Sender.AsString);
end;

procedure TFViewFornecedoresEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFornecedoresEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fornecedores.form.lbid');
  lbrazao_social_nome := TLabel.Create('view.fornecedores.form.lbrazao_social_nome');
  lbnome_fantasia_apelido := TLabel.Create('view.fornecedores.form.lbnome_fantasia_apelido');
  lbcpf_cnpj := TLabel.Create('view.fornecedores.form.lbcpf_cnpj');
  lbrg_ie := TLabel.Create('view.fornecedores.form.lbrg_ie');
  lbis_pj := TLabel.Create('view.fornecedores.form.lbis_pj');
  lbcadastro := TLabel.Create('view.fornecedores.form.lbcadastro');
  lbstatus := TLabel.Create('view.fornecedores.form.lbstatus');
  lbemail := TLabel.Create('view.fornecedores.form.lbemail');
  lbcontato := TLabel.Create('view.fornecedores.form.lbcontato');
  lbendereco := TLabel.Create('view.fornecedores.form.lbendereco');
  lbcep := TLabel.Create('view.fornecedores.form.lbcep');
  lbcidade_id := TLabel.Create('view.fornecedores.form.lbcidade_id');
  lbtelefones := TLabel.Create('view.fornecedores.form.lbtelefones');
  lbprodutor_rural := TLabel.Create('view.fornecedores.form.lbprodutor_rural');
  lbcodigo_interno := TLabel.Create('view.fornecedores.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.fornecedores.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fornecedores.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fornecedores.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fornecedores.form.lbexclusao');
  btCancel := TButton.Create('view.fornecedores.form.btBack');
  edid := TDBEdit.Create('view.fornecedores.form.edid');
  edrazao_social_nome := TDBEdit.Create('view.fornecedores.form.edrazao_social_nome');
  ednome_fantasia_apelido := TDBEdit.Create('view.fornecedores.form.ednome_fantasia_apelido');
  edcpf_cnpj := TDBEdit.Create('view.fornecedores.form.edcpf_cnpj');
  edrg_ie := TDBEdit.Create('view.fornecedores.form.edrg_ie');
  edcadastro := TDBEdit.Create('view.fornecedores.form.edcadastro');
  edstatus := TDBEdit.Create('view.fornecedores.form.edstatus');
  edemail := TDBEdit.Create('view.fornecedores.form.edemail');
  edcontato := TDBEdit.Create('view.fornecedores.form.edcontato');
  edendereco := TDBEdit.Create('view.fornecedores.form.edendereco');
  edcep := TDBEdit.Create('view.fornecedores.form.edcep');
  edcidade_id := TDBEdit.Create('view.fornecedores.form.edcidade_id');
  edtelefones := TDBEdit.Create('view.fornecedores.form.edtelefones');
  edcodigo_interno := TDBEdit.Create('view.fornecedores.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.fornecedores.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fornecedores.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fornecedores.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.fornecedores.form.cbxexcluido');
  cbxis_pj := TDBCheckBox.Create('view.fornecedores.form.cbxis_pj');
  cbxprodutor_rural := TDBCheckBox.Create('view.fornecedores.form.cbxprodutor_rural');
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  frmFinanceiro := TfrmFinanceiroFornecedor.Create(Self);
  DataSource := TDataSource.Create(Self);
  FornecedoresDataset := TXDataWebDataSet.Create(Self);
  FornecedoresDatasetid := TIntegerField.Create(Self);
  FornecedoresDatasetaliado_id := TIntegerField.Create(Self);
  FornecedoresDatasetdata_base_id := TIntegerField.Create(Self);
  FornecedoresDatasetrazao_social_nome := TStringField.Create(Self);
  FornecedoresDatasetnome_fantasia_apelido := TStringField.Create(Self);
  FornecedoresDatasetcpf_cnpj := TStringField.Create(Self);
  FornecedoresDatasetrg_ie := TStringField.Create(Self);
  FornecedoresDatasetis_pj := TBooleanField.Create(Self);
  FornecedoresDatasetcadastro := TDateTimeField.Create(Self);
  FornecedoresDatasetstatus := TIntegerField.Create(Self);
  FornecedoresDatasetemail := TStringField.Create(Self);
  FornecedoresDatasetcontato := TStringField.Create(Self);
  FornecedoresDatasetendereco := TStringField.Create(Self);
  FornecedoresDatasetnumero := TStringField.Create(Self);
  FornecedoresDatasetbairro := TStringField.Create(Self);
  FornecedoresDatasetcomplemento := TStringField.Create(Self);
  FornecedoresDatasetcep := TStringField.Create(Self);
  FornecedoresDatasetcidade_id := TIntegerField.Create(Self);
  FornecedoresDatasettelefones := TStringField.Create(Self);
  FornecedoresDatasetprodutor_rural := TBooleanField.Create(Self);
  FornecedoresDatasetcodigo_interno := TIntegerField.Create(Self);
  FornecedoresDatasetexcluido := TBooleanField.Create(Self);
  FornecedoresDatasetinclusao := TDateTimeField.Create(Self);
  FornecedoresDatasetalteracao := TDateTimeField.Create(Self);
  FornecedoresDatasetexclusao := TDateTimeField.Create(Self);
  FornecedoresDatasetcidadeNome := TStringField.Create(Self);
  FornecedoresDatasetcidadeufSigla := TStringField.Create(Self);
  XDataClientFornecedoresGet := TXDataWebClient.Create(Self);

  frmFinanceiro.LoadFromForm;
  lbid.BeforeLoadDFMValues;
  lbrazao_social_nome.BeforeLoadDFMValues;
  lbnome_fantasia_apelido.BeforeLoadDFMValues;
  lbcpf_cnpj.BeforeLoadDFMValues;
  lbrg_ie.BeforeLoadDFMValues;
  lbis_pj.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  lbcontato.BeforeLoadDFMValues;
  lbendereco.BeforeLoadDFMValues;
  lbcep.BeforeLoadDFMValues;
  lbcidade_id.BeforeLoadDFMValues;
  lbtelefones.BeforeLoadDFMValues;
  lbprodutor_rural.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edrazao_social_nome.BeforeLoadDFMValues;
  ednome_fantasia_apelido.BeforeLoadDFMValues;
  edcpf_cnpj.BeforeLoadDFMValues;
  edrg_ie.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  edcontato.BeforeLoadDFMValues;
  edendereco.BeforeLoadDFMValues;
  edcep.BeforeLoadDFMValues;
  edcidade_id.BeforeLoadDFMValues;
  edtelefones.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxis_pj.BeforeLoadDFMValues;
  cbxprodutor_rural.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  frmFinanceiro.BeforeLoadDFMValues;
  frmFinanceiro.lbPaginationInfoDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosAVencer.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosVencidos.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblUltimaCompra.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalCompras.BeforeLoadDFMValues;
  frmFinanceiro.lblQuantidadeCompras.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  FornecedoresDataset.BeforeLoadDFMValues;
  FornecedoresDatasetid.BeforeLoadDFMValues;
  FornecedoresDatasetaliado_id.BeforeLoadDFMValues;
  FornecedoresDatasetdata_base_id.BeforeLoadDFMValues;
  FornecedoresDatasetrazao_social_nome.BeforeLoadDFMValues;
  FornecedoresDatasetnome_fantasia_apelido.BeforeLoadDFMValues;
  FornecedoresDatasetcpf_cnpj.BeforeLoadDFMValues;
  FornecedoresDatasetrg_ie.BeforeLoadDFMValues;
  FornecedoresDatasetis_pj.BeforeLoadDFMValues;
  FornecedoresDatasetcadastro.BeforeLoadDFMValues;
  FornecedoresDatasetstatus.BeforeLoadDFMValues;
  FornecedoresDatasetemail.BeforeLoadDFMValues;
  FornecedoresDatasetcontato.BeforeLoadDFMValues;
  FornecedoresDatasetendereco.BeforeLoadDFMValues;
  FornecedoresDatasetnumero.BeforeLoadDFMValues;
  FornecedoresDatasetbairro.BeforeLoadDFMValues;
  FornecedoresDatasetcomplemento.BeforeLoadDFMValues;
  FornecedoresDatasetcep.BeforeLoadDFMValues;
  FornecedoresDatasetcidade_id.BeforeLoadDFMValues;
  FornecedoresDatasettelefones.BeforeLoadDFMValues;
  FornecedoresDatasetprodutor_rural.BeforeLoadDFMValues;
  FornecedoresDatasetcodigo_interno.BeforeLoadDFMValues;
  FornecedoresDatasetexcluido.BeforeLoadDFMValues;
  FornecedoresDatasetinclusao.BeforeLoadDFMValues;
  FornecedoresDatasetalteracao.BeforeLoadDFMValues;
  FornecedoresDatasetexclusao.BeforeLoadDFMValues;
  FornecedoresDatasetcidadeNome.BeforeLoadDFMValues;
  FornecedoresDatasetcidadeufSigla.BeforeLoadDFMValues;
  XDataClientFornecedoresGet.BeforeLoadDFMValues;
  try
    Name := 'FViewFornecedoresEdit';
    Width := 699;
    Height := 604;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 6;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbrazao_social_nome.SetParentComponent(Self);
    lbrazao_social_nome.Name := 'lbrazao_social_nome';
    lbrazao_social_nome.Left := 8;
    lbrazao_social_nome.Top := 33;
    lbrazao_social_nome.Width := 95;
    lbrazao_social_nome.Height := 13;
    lbrazao_social_nome.Caption := 'Nome/Raz'#227'o Social:';
    lbrazao_social_nome.HeightPercent := 100.000000000000000000;
    lbrazao_social_nome.WidthPercent := 100.000000000000000000;
    lbnome_fantasia_apelido.SetParentComponent(Self);
    lbnome_fantasia_apelido.Name := 'lbnome_fantasia_apelido';
    lbnome_fantasia_apelido.Left := 8;
    lbnome_fantasia_apelido.Top := 60;
    lbnome_fantasia_apelido.Width := 114;
    lbnome_fantasia_apelido.Height := 13;
    lbnome_fantasia_apelido.Caption := 'Apelido/Nome Fantasia:';
    lbnome_fantasia_apelido.HeightPercent := 100.000000000000000000;
    lbnome_fantasia_apelido.WidthPercent := 100.000000000000000000;
    lbcpf_cnpj.SetParentComponent(Self);
    lbcpf_cnpj.Name := 'lbcpf_cnpj';
    lbcpf_cnpj.Left := 8;
    lbcpf_cnpj.Top := 87;
    lbcpf_cnpj.Width := 58;
    lbcpf_cnpj.Height := 13;
    lbcpf_cnpj.Caption := 'Documento:';
    lbcpf_cnpj.HeightPercent := 100.000000000000000000;
    lbcpf_cnpj.WidthPercent := 100.000000000000000000;
    lbrg_ie.SetParentComponent(Self);
    lbrg_ie.Name := 'lbrg_ie';
    lbrg_ie.Left := 8;
    lbrg_ie.Top := 114;
    lbrg_ie.Width := 32;
    lbrg_ie.Height := 13;
    lbrg_ie.Caption := 'RG/IE:';
    lbrg_ie.HeightPercent := 100.000000000000000000;
    lbrg_ie.WidthPercent := 100.000000000000000000;
    lbis_pj.SetParentComponent(Self);
    lbis_pj.Name := 'lbis_pj';
    lbis_pj.Left := 8;
    lbis_pj.Top := 141;
    lbis_pj.Width := 78;
    lbis_pj.Height := 13;
    lbis_pj.Caption := 'Pessoa Jur'#237'dica?';
    lbis_pj.HeightPercent := 100.000000000000000000;
    lbis_pj.WidthPercent := 100.000000000000000000;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 8;
    lbcadastro.Top := 168;
    lbcadastro.Width := 48;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'Cadastro:';
    lbcadastro.HeightPercent := 100.000000000000000000;
    lbcadastro.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 8;
    lbstatus.Top := 195;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 8;
    lbemail.Top := 222;
    lbemail.Width := 28;
    lbemail.Height := 13;
    lbemail.Caption := 'Email:';
    lbemail.HeightPercent := 100.000000000000000000;
    lbemail.WidthPercent := 100.000000000000000000;
    lbcontato.SetParentComponent(Self);
    lbcontato.Name := 'lbcontato';
    lbcontato.Left := 8;
    lbcontato.Top := 249;
    lbcontato.Width := 43;
    lbcontato.Height := 13;
    lbcontato.Caption := 'Contato:';
    lbcontato.HeightPercent := 100.000000000000000000;
    lbcontato.WidthPercent := 100.000000000000000000;
    lbendereco.SetParentComponent(Self);
    lbendereco.Name := 'lbendereco';
    lbendereco.Left := 8;
    lbendereco.Top := 276;
    lbendereco.Width := 49;
    lbendereco.Height := 13;
    lbendereco.Caption := 'Endere'#231'o:';
    lbendereco.HeightPercent := 100.000000000000000000;
    lbendereco.WidthPercent := 100.000000000000000000;
    lbcep.SetParentComponent(Self);
    lbcep.Name := 'lbcep';
    lbcep.Left := 265;
    lbcep.Top := 6;
    lbcep.Width := 23;
    lbcep.Height := 13;
    lbcep.Caption := 'Cep:';
    lbcep.HeightPercent := 100.000000000000000000;
    lbcep.WidthPercent := 100.000000000000000000;
    lbcidade_id.SetParentComponent(Self);
    lbcidade_id.Name := 'lbcidade_id';
    lbcidade_id.Left := 265;
    lbcidade_id.Top := 33;
    lbcidade_id.Width := 37;
    lbcidade_id.Height := 13;
    lbcidade_id.Caption := 'Cidade:';
    lbcidade_id.HeightPercent := 100.000000000000000000;
    lbcidade_id.WidthPercent := 100.000000000000000000;
    lbtelefones.SetParentComponent(Self);
    lbtelefones.Name := 'lbtelefones';
    lbtelefones.Left := 265;
    lbtelefones.Top := 60;
    lbtelefones.Width := 51;
    lbtelefones.Height := 13;
    lbtelefones.Caption := 'Telefones:';
    lbtelefones.HeightPercent := 100.000000000000000000;
    lbtelefones.WidthPercent := 100.000000000000000000;
    lbprodutor_rural.SetParentComponent(Self);
    lbprodutor_rural.Name := 'lbprodutor_rural';
    lbprodutor_rural.Left := 265;
    lbprodutor_rural.Top := 87;
    lbprodutor_rural.Width := 75;
    lbprodutor_rural.Height := 13;
    lbprodutor_rural.Caption := 'Produtor Rural?';
    lbprodutor_rural.HeightPercent := 100.000000000000000000;
    lbprodutor_rural.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 265;
    lbcodigo_interno.Top := 114;
    lbcodigo_interno.Width := 47;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 265;
    lbexcluido.Top := 141;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 265;
    lbinclusao.Top := 168;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 265;
    lbalteracao.Top := 195;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 265;
    lbexclusao.Top := 222;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 588;
    btCancel.Top := 7;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 125;
    edid.Top := 3;
    edid.Width := 120;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edrazao_social_nome.SetParentComponent(Self);
    edrazao_social_nome.Name := 'edrazao_social_nome';
    edrazao_social_nome.Left := 125;
    edrazao_social_nome.Top := 30;
    edrazao_social_nome.Width := 120;
    edrazao_social_nome.Height := 21;
    edrazao_social_nome.Enabled := False;
    edrazao_social_nome.HeightPercent := 100.000000000000000000;
    edrazao_social_nome.TabOrder := 9;
    edrazao_social_nome.Text := 'edrazao_social_nome';
    edrazao_social_nome.WidthPercent := 100.000000000000000000;
    edrazao_social_nome.DataField := 'razao_social_nome';
    edrazao_social_nome.DataSource := DataSource;
    ednome_fantasia_apelido.SetParentComponent(Self);
    ednome_fantasia_apelido.Name := 'ednome_fantasia_apelido';
    ednome_fantasia_apelido.Left := 125;
    ednome_fantasia_apelido.Top := 57;
    ednome_fantasia_apelido.Width := 120;
    ednome_fantasia_apelido.Height := 21;
    ednome_fantasia_apelido.Enabled := False;
    ednome_fantasia_apelido.HeightPercent := 100.000000000000000000;
    ednome_fantasia_apelido.TabOrder := 10;
    ednome_fantasia_apelido.Text := 'ednome_fantasia_apelido';
    ednome_fantasia_apelido.WidthPercent := 100.000000000000000000;
    ednome_fantasia_apelido.DataField := 'nome_fantasia_apelido';
    ednome_fantasia_apelido.DataSource := DataSource;
    edcpf_cnpj.SetParentComponent(Self);
    edcpf_cnpj.Name := 'edcpf_cnpj';
    edcpf_cnpj.Left := 125;
    edcpf_cnpj.Top := 84;
    edcpf_cnpj.Width := 120;
    edcpf_cnpj.Height := 21;
    edcpf_cnpj.Enabled := False;
    edcpf_cnpj.HeightPercent := 100.000000000000000000;
    edcpf_cnpj.TabOrder := 11;
    edcpf_cnpj.Text := 'edcpf_cnpj';
    edcpf_cnpj.WidthPercent := 100.000000000000000000;
    edcpf_cnpj.DataField := 'cpf_cnpj';
    edcpf_cnpj.DataSource := DataSource;
    edrg_ie.SetParentComponent(Self);
    edrg_ie.Name := 'edrg_ie';
    edrg_ie.Left := 125;
    edrg_ie.Top := 111;
    edrg_ie.Width := 120;
    edrg_ie.Height := 21;
    edrg_ie.Enabled := False;
    edrg_ie.HeightPercent := 100.000000000000000000;
    edrg_ie.TabOrder := 12;
    edrg_ie.Text := 'edrg_ie';
    edrg_ie.WidthPercent := 100.000000000000000000;
    edrg_ie.DataField := 'rg_ie';
    edrg_ie.DataSource := DataSource;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 125;
    edcadastro.Top := 165;
    edcadastro.Width := 120;
    edcadastro.Height := 21;
    edcadastro.Enabled := False;
    edcadastro.HeightPercent := 100.000000000000000000;
    edcadastro.TabOrder := 14;
    edcadastro.Text := 'edcadastro';
    edcadastro.WidthPercent := 100.000000000000000000;
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 125;
    edstatus.Top := 192;
    edstatus.Width := 120;
    edstatus.Height := 21;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 15;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 125;
    edemail.Top := 219;
    edemail.Width := 120;
    edemail.Height := 21;
    edemail.Enabled := False;
    edemail.HeightPercent := 100.000000000000000000;
    edemail.TabOrder := 16;
    edemail.Text := 'edemail';
    edemail.WidthPercent := 100.000000000000000000;
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    edcontato.SetParentComponent(Self);
    edcontato.Name := 'edcontato';
    edcontato.Left := 125;
    edcontato.Top := 246;
    edcontato.Width := 120;
    edcontato.Height := 21;
    edcontato.Enabled := False;
    edcontato.HeightPercent := 100.000000000000000000;
    edcontato.TabOrder := 17;
    edcontato.Text := 'edcontato';
    edcontato.WidthPercent := 100.000000000000000000;
    edcontato.DataField := 'contato';
    edcontato.DataSource := DataSource;
    edendereco.SetParentComponent(Self);
    edendereco.Name := 'edendereco';
    edendereco.Left := 125;
    edendereco.Top := 273;
    edendereco.Width := 120;
    edendereco.Height := 21;
    edendereco.Enabled := False;
    edendereco.HeightPercent := 100.000000000000000000;
    edendereco.TabOrder := 18;
    edendereco.Text := 'edendereco';
    edendereco.WidthPercent := 100.000000000000000000;
    edendereco.DataField := 'endereco';
    edendereco.DataSource := DataSource;
    edcep.SetParentComponent(Self);
    edcep.Name := 'edcep';
    edcep.Left := 462;
    edcep.Top := 3;
    edcep.Width := 120;
    edcep.Height := 21;
    edcep.Enabled := False;
    edcep.HeightPercent := 100.000000000000000000;
    edcep.TabOrder := 22;
    edcep.Text := 'edcep';
    edcep.WidthPercent := 100.000000000000000000;
    edcep.DataField := 'cep';
    edcep.DataSource := DataSource;
    edcidade_id.SetParentComponent(Self);
    edcidade_id.Name := 'edcidade_id';
    edcidade_id.Left := 462;
    edcidade_id.Top := 30;
    edcidade_id.Width := 120;
    edcidade_id.Height := 21;
    edcidade_id.Enabled := False;
    edcidade_id.HeightPercent := 100.000000000000000000;
    edcidade_id.TabOrder := 23;
    edcidade_id.Text := 'edcidade_id';
    edcidade_id.WidthPercent := 100.000000000000000000;
    edcidade_id.DataField := 'cidade.Nome';
    edcidade_id.DataSource := DataSource;
    edtelefones.SetParentComponent(Self);
    edtelefones.Name := 'edtelefones';
    edtelefones.Left := 462;
    edtelefones.Top := 57;
    edtelefones.Width := 120;
    edtelefones.Height := 21;
    edtelefones.Enabled := False;
    edtelefones.HeightPercent := 100.000000000000000000;
    edtelefones.TabOrder := 24;
    edtelefones.Text := 'edtelefones';
    edtelefones.WidthPercent := 100.000000000000000000;
    edtelefones.DataField := 'telefones';
    edtelefones.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 462;
    edcodigo_interno.Top := 111;
    edcodigo_interno.Width := 120;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 26;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 462;
    edinclusao.Top := 165;
    edinclusao.Width := 120;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 28;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 462;
    edalteracao.Top := 192;
    edalteracao.Width := 120;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 29;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 462;
    edexclusao.Top := 219;
    edexclusao.Width := 120;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 30;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 462;
    cbxexcluido.Top := 138;
    cbxexcluido.Width := 114;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxis_pj.SetParentComponent(Self);
    cbxis_pj.Name := 'cbxis_pj';
    cbxis_pj.Left := 125;
    cbxis_pj.Top := 138;
    cbxis_pj.Width := 120;
    cbxis_pj.Height := 22;
    cbxis_pj.Caption := 'cbxis_pj';
    cbxis_pj.ChildOrder := 33;
    cbxis_pj.Enabled := False;
    cbxis_pj.HeightPercent := 100.000000000000000000;
    cbxis_pj.WidthPercent := 100.000000000000000000;
    cbxis_pj.DataField := 'is_pj';
    cbxis_pj.DataSource := DataSource;
    cbxprodutor_rural.SetParentComponent(Self);
    cbxprodutor_rural.Name := 'cbxprodutor_rural';
    cbxprodutor_rural.Left := 462;
    cbxprodutor_rural.Top := 84;
    cbxprodutor_rural.Width := 120;
    cbxprodutor_rural.Height := 22;
    cbxprodutor_rural.Caption := 'cbxprodutor_rural';
    cbxprodutor_rural.ChildOrder := 33;
    cbxprodutor_rural.Enabled := False;
    cbxprodutor_rural.HeightPercent := 100.000000000000000000;
    cbxprodutor_rural.WidthPercent := 100.000000000000000000;
    cbxprodutor_rural.DataField := 'produtor_rural';
    cbxprodutor_rural.DataSource := DataSource;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 588;
    btnFinanceiroTab.Top := 38;
    btnFinanceiroTab.Width := 96;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 16;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabStop := False;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    frmFinanceiro.SetParentComponent(Self);
    frmFinanceiro.Name := 'frmFinanceiro';
    frmFinanceiro.Left := 8;
    frmFinanceiro.Top := 320;
    frmFinanceiro.Width := 564;
    frmFinanceiro.Height := 253;
    frmFinanceiro.TabOrder := 22;
    frmFinanceiro.Visible := False;
    frmFinanceiro.lbPaginationInfoDebitos.Width := 141;
    frmFinanceiro.lbPaginationInfoDebitos.Height := 13;
    frmFinanceiro.lblDebitosAVencer.Width := 4;
    frmFinanceiro.lblDebitosAVencer.Height := 13;
    frmFinanceiro.lblDebitosVencidos.Width := 4;
    frmFinanceiro.lblDebitosVencidos.Height := 13;
    frmFinanceiro.lblTotalDebitos.Width := 4;
    frmFinanceiro.lblTotalDebitos.Height := 13;
    frmFinanceiro.lblUltimaCompra.Width := 4;
    frmFinanceiro.lblUltimaCompra.Height := 13;
    frmFinanceiro.lblTotalCompras.Width := 4;
    frmFinanceiro.lblTotalCompras.Height := 13;
    frmFinanceiro.lblQuantidadeCompras.Width := 4;
    frmFinanceiro.lblQuantidadeCompras.Height := 13;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := FornecedoresDataset;
    DataSource.Left := 384;
    DataSource.Top := 248;
    FornecedoresDataset.SetParentComponent(Self);
    FornecedoresDataset.Name := 'FornecedoresDataset';
    FornecedoresDataset.AfterApplyUpdates := FornecedoresDatasetAfterApplyUpdates;
    FornecedoresDataset.EntitySetName := 'Fornecedores';
    FornecedoresDataset.Connection := DMConnection.ApiConnection;
    FornecedoresDataset.Left := 456;
    FornecedoresDataset.Top := 248;
    FornecedoresDatasetid.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetid.Name := 'FornecedoresDatasetid';
    FornecedoresDatasetid.FieldName := 'id';
    FornecedoresDatasetid.Required := True;
    FornecedoresDatasetaliado_id.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetaliado_id.Name := 'FornecedoresDatasetaliado_id';
    FornecedoresDatasetaliado_id.FieldName := 'aliado_id';
    FornecedoresDatasetaliado_id.Required := True;
    FornecedoresDatasetdata_base_id.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetdata_base_id.Name := 'FornecedoresDatasetdata_base_id';
    FornecedoresDatasetdata_base_id.FieldName := 'data_base_id';
    FornecedoresDatasetdata_base_id.Required := True;
    FornecedoresDatasetrazao_social_nome.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetrazao_social_nome.Name := 'FornecedoresDatasetrazao_social_nome';
    FornecedoresDatasetrazao_social_nome.FieldName := 'razao_social_nome';
    FornecedoresDatasetrazao_social_nome.Required := True;
    FornecedoresDatasetrazao_social_nome.Size := 255;
    FornecedoresDatasetnome_fantasia_apelido.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetnome_fantasia_apelido.Name := 'FornecedoresDatasetnome_fantasia_apelido';
    FornecedoresDatasetnome_fantasia_apelido.FieldName := 'nome_fantasia_apelido';
    FornecedoresDatasetnome_fantasia_apelido.Size := 255;
    FornecedoresDatasetcpf_cnpj.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcpf_cnpj.Name := 'FornecedoresDatasetcpf_cnpj';
    FornecedoresDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    SetEvent(FornecedoresDatasetcpf_cnpj, Self, 'OnGetText', 'FornecedoresDatasetcpf_cnpjGetText');
    FornecedoresDatasetcpf_cnpj.Size := 255;
    FornecedoresDatasetrg_ie.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetrg_ie.Name := 'FornecedoresDatasetrg_ie';
    FornecedoresDatasetrg_ie.FieldName := 'rg_ie';
    FornecedoresDatasetrg_ie.Size := 255;
    FornecedoresDatasetis_pj.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetis_pj.Name := 'FornecedoresDatasetis_pj';
    FornecedoresDatasetis_pj.FieldName := 'is_pj';
    FornecedoresDatasetcadastro.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcadastro.Name := 'FornecedoresDatasetcadastro';
    FornecedoresDatasetcadastro.FieldName := 'cadastro';
    FornecedoresDatasetcadastro.DisplayFormat := 'dd/mm/yy';
    FornecedoresDatasetstatus.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetstatus.Name := 'FornecedoresDatasetstatus';
    FornecedoresDatasetstatus.FieldName := 'status';
    FornecedoresDatasetstatus.Required := True;
    SetEvent(FornecedoresDatasetstatus, Self, 'OnGetText', 'FornecedoresDatasetstatusGetText');
    FornecedoresDatasetemail.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetemail.Name := 'FornecedoresDatasetemail';
    FornecedoresDatasetemail.FieldName := 'email';
    SetEvent(FornecedoresDatasetemail, Self, 'OnGetText', 'FornecedoresDatasetemailGetText');
    FornecedoresDatasetemail.Size := 255;
    FornecedoresDatasetcontato.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcontato.Name := 'FornecedoresDatasetcontato';
    FornecedoresDatasetcontato.FieldName := 'contato';
    FornecedoresDatasetcontato.Size := 255;
    FornecedoresDatasetendereco.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetendereco.Name := 'FornecedoresDatasetendereco';
    FornecedoresDatasetendereco.FieldName := 'endereco';
    SetEvent(FornecedoresDatasetendereco, Self, 'OnGetText', 'FornecedoresDatasetenderecoGetText');
    FornecedoresDatasetendereco.Size := 255;
    FornecedoresDatasetnumero.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetnumero.Name := 'FornecedoresDatasetnumero';
    FornecedoresDatasetnumero.FieldName := 'numero';
    FornecedoresDatasetnumero.Size := 255;
    FornecedoresDatasetbairro.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetbairro.Name := 'FornecedoresDatasetbairro';
    FornecedoresDatasetbairro.FieldName := 'bairro';
    FornecedoresDatasetbairro.Size := 255;
    FornecedoresDatasetcomplemento.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcomplemento.Name := 'FornecedoresDatasetcomplemento';
    FornecedoresDatasetcomplemento.FieldName := 'complemento';
    FornecedoresDatasetcomplemento.Size := 255;
    FornecedoresDatasetcep.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcep.Name := 'FornecedoresDatasetcep';
    FornecedoresDatasetcep.FieldName := 'cep';
    FornecedoresDatasetcep.Required := True;
    FornecedoresDatasetcep.Size := 255;
    FornecedoresDatasetcidade_id.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcidade_id.Name := 'FornecedoresDatasetcidade_id';
    FornecedoresDatasetcidade_id.FieldName := 'cidade_id';
    FornecedoresDatasettelefones.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasettelefones.Name := 'FornecedoresDatasettelefones';
    FornecedoresDatasettelefones.FieldName := 'telefones';
    FornecedoresDatasettelefones.Required := True;
    SetEvent(FornecedoresDatasettelefones, Self, 'OnGetText', 'FornecedoresDatasettelefonesGetText');
    FornecedoresDatasettelefones.Size := 255;
    FornecedoresDatasetprodutor_rural.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetprodutor_rural.Name := 'FornecedoresDatasetprodutor_rural';
    FornecedoresDatasetprodutor_rural.FieldName := 'produtor_rural';
    FornecedoresDatasetcodigo_interno.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcodigo_interno.Name := 'FornecedoresDatasetcodigo_interno';
    FornecedoresDatasetcodigo_interno.FieldName := 'codigo_interno';
    FornecedoresDatasetcodigo_interno.Required := True;
    FornecedoresDatasetexcluido.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetexcluido.Name := 'FornecedoresDatasetexcluido';
    FornecedoresDatasetexcluido.FieldName := 'excluido';
    FornecedoresDatasetinclusao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetinclusao.Name := 'FornecedoresDatasetinclusao';
    FornecedoresDatasetinclusao.FieldName := 'inclusao';
    FornecedoresDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetalteracao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetalteracao.Name := 'FornecedoresDatasetalteracao';
    FornecedoresDatasetalteracao.FieldName := 'alteracao';
    FornecedoresDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetexclusao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetexclusao.Name := 'FornecedoresDatasetexclusao';
    FornecedoresDatasetexclusao.FieldName := 'exclusao';
    FornecedoresDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetcidadeNome.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcidadeNome.Name := 'FornecedoresDatasetcidadeNome';
    FornecedoresDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(FornecedoresDatasetcidadeNome, Self, 'OnGetText', 'FornecedoresDatasetcidadeNomeGetText');
    FornecedoresDatasetcidadeufSigla.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcidadeufSigla.Name := 'FornecedoresDatasetcidadeufSigla';
    FornecedoresDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    XDataClientFornecedoresGet.SetParentComponent(Self);
    XDataClientFornecedoresGet.Name := 'XDataClientFornecedoresGet';
    XDataClientFornecedoresGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFornecedoresGet, Self, 'OnLoad', 'XDataClientFornecedoresGetLoad');
    XDataClientFornecedoresGet.Left := 528;
    XDataClientFornecedoresGet.Top := 248;
  finally
    lbid.AfterLoadDFMValues;
    lbrazao_social_nome.AfterLoadDFMValues;
    lbnome_fantasia_apelido.AfterLoadDFMValues;
    lbcpf_cnpj.AfterLoadDFMValues;
    lbrg_ie.AfterLoadDFMValues;
    lbis_pj.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    lbcontato.AfterLoadDFMValues;
    lbendereco.AfterLoadDFMValues;
    lbcep.AfterLoadDFMValues;
    lbcidade_id.AfterLoadDFMValues;
    lbtelefones.AfterLoadDFMValues;
    lbprodutor_rural.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edrazao_social_nome.AfterLoadDFMValues;
    ednome_fantasia_apelido.AfterLoadDFMValues;
    edcpf_cnpj.AfterLoadDFMValues;
    edrg_ie.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    edcontato.AfterLoadDFMValues;
    edendereco.AfterLoadDFMValues;
    edcep.AfterLoadDFMValues;
    edcidade_id.AfterLoadDFMValues;
    edtelefones.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxis_pj.AfterLoadDFMValues;
    cbxprodutor_rural.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    frmFinanceiro.AfterLoadDFMValues;
    frmFinanceiro.lbPaginationInfoDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosAVencer.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosVencidos.AfterLoadDFMValues;
    frmFinanceiro.lblTotalDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblUltimaCompra.AfterLoadDFMValues;
    frmFinanceiro.lblTotalCompras.AfterLoadDFMValues;
    frmFinanceiro.lblQuantidadeCompras.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    FornecedoresDataset.AfterLoadDFMValues;
    FornecedoresDatasetid.AfterLoadDFMValues;
    FornecedoresDatasetaliado_id.AfterLoadDFMValues;
    FornecedoresDatasetdata_base_id.AfterLoadDFMValues;
    FornecedoresDatasetrazao_social_nome.AfterLoadDFMValues;
    FornecedoresDatasetnome_fantasia_apelido.AfterLoadDFMValues;
    FornecedoresDatasetcpf_cnpj.AfterLoadDFMValues;
    FornecedoresDatasetrg_ie.AfterLoadDFMValues;
    FornecedoresDatasetis_pj.AfterLoadDFMValues;
    FornecedoresDatasetcadastro.AfterLoadDFMValues;
    FornecedoresDatasetstatus.AfterLoadDFMValues;
    FornecedoresDatasetemail.AfterLoadDFMValues;
    FornecedoresDatasetcontato.AfterLoadDFMValues;
    FornecedoresDatasetendereco.AfterLoadDFMValues;
    FornecedoresDatasetnumero.AfterLoadDFMValues;
    FornecedoresDatasetbairro.AfterLoadDFMValues;
    FornecedoresDatasetcomplemento.AfterLoadDFMValues;
    FornecedoresDatasetcep.AfterLoadDFMValues;
    FornecedoresDatasetcidade_id.AfterLoadDFMValues;
    FornecedoresDatasettelefones.AfterLoadDFMValues;
    FornecedoresDatasetprodutor_rural.AfterLoadDFMValues;
    FornecedoresDatasetcodigo_interno.AfterLoadDFMValues;
    FornecedoresDatasetexcluido.AfterLoadDFMValues;
    FornecedoresDatasetinclusao.AfterLoadDFMValues;
    FornecedoresDatasetalteracao.AfterLoadDFMValues;
    FornecedoresDatasetexclusao.AfterLoadDFMValues;
    FornecedoresDatasetcidadeNome.AfterLoadDFMValues;
    FornecedoresDatasetcidadeufSigla.AfterLoadDFMValues;
    XDataClientFornecedoresGet.AfterLoadDFMValues;
  end;
end;

end.
